import { createSerializer, parseAsBoolean } from 'nuqs';

/** URL search params read by the policy CSV import route. */
export const policyImportSearchParams = {
	/** Opens the import with "This is a data refresh" already checked. */
	dataRefresh: parseAsBoolean.withDefault(false),
};

/**
 * Builds a policy CSV import URL carrying {@link policyImportSearchParams}, e.g.
 * `serializePolicyImportSearchParams('/dataBoards/policies/contacts-self-import', { dataRefresh: true })`
 * -> `'/dataBoards/policies/contacts-self-import?dataRefresh=true'`.
 */
export const serializePolicyImportSearchParams = createSerializer(policyImportSearchParams);
